function redirectPage() {
    var whiteList = [];
    var base = "https://www.ecoorganicgarden.com.au/";
    var pathname = location.pathname.replace(/^\//g, "").replace(/\/$/g, "");
    var search = decodeURIComponent(location.search);
    var redirectPath = decodeURIComponent(pathname);
    var paths = Boolean(location.pathname) ? pathname.split('/').filter(function(item) {
        return !!(item)
    }) : [];
    const found = whiteList.some(item => paths.includes(item));
    if(found) return;
    if(paths.length > 0) {
      url = base + 'umbraco/api/shopify/redirecturl?path=' + encodeURIComponent(redirectPath) + encodeURIComponent(search);
      $.ajax({
        type: 'GET',
        url: url,
        crossDomain: true,
      }).done(function (data) {
        debugger;
        url = data
        return window.location.replace(data);
      }).fail(function (xhr, status) {
        debugger;
        url = base;
        return window.location.replace(url);
      });
    } else {
      url = base;
      return window.location.replace(url);
    }
}